import React from "react";
import Timer from "react-compound-timer";

const Counter = (props) => {
  return (
    <Timer
      {...props}
      checkpoints={[
        {
          time: 0,
          callback: () => props.onFinish && props.onFinish(),
        },
      ]}
    >
      <Timer.Minutes />
      {":"}
      <Timer.Seconds />
    </Timer>
  );
};

export default Counter;
